/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Entity_Userid1Inputs */

const en_entity_userid1 = /** @type {(inputs: Entity_Userid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`User ID`)
};

const de_entity_userid1 = /** @type {(inputs: Entity_Userid1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzer-ID`)
};

/**
* | output |
* | --- |
* | "User ID" |
*
* @param {Entity_Userid1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const entity_userid1 = /** @type {((inputs?: Entity_Userid1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Entity_Userid1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_entity_userid1(inputs)
	return de_entity_userid1(inputs)
});
export { entity_userid1 as "entity_userId" }